export enum PrintImages {
  'VUE背景'= 'https://cn.bing.com/th?id=OHR.SmithRock_ZH-CN6383276214_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp',
}

/*模板对应高度*/
export enum PrintImageSizes {
  'https://cn.bing.com/th?id=OHR.SmithRock_ZH-CN6383276214_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp'='600x400'
}

export function getPrintImageSize(printSize:PrintImageSizes):{width:number,height:number} {
  let width:number = 0;
  let height:number = 0;
  let arr = printSize.split('x');
  width = +arr[0];
  height = +arr[1];
  return {width,height};

}
